module.exports = __webpack_public_path__ + "static/media/certificationBackground.1ad135a6.jpg";